import PropTypes from "prop-types";
import { SFStack, SFUseStyled } from "@sf-core";

const { styled } = SFUseStyled();

// const ProgressBar = ({ value }) => (
//   <svg
//     width="100"
//     height="3"
//     viewBox="0 0 100 3"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <rect x={0} width={value} height="3" rx="1.5" fill="#4EBEEB" />
//     <rect
//       opacity="0.4"
//       x={value}
//       width={100 - value}
//       height="3"
//       rx="1.5"
//       fill="#747480"
//     />
//   </svg>
// );

const ProgressBarStyled = styled("div")(({ value, theme }) => ({
  width: "100%",
  height: "3px",
  backgroundColor: "#747480",
  borderRadius: 4,
  "& .complete": {
    width: `${value}%`,
    height: "3px",
    backgroundColor: "#4EBEEB",
    borderRadius: 4,
  },
}));

const SFMatchRenderer = ({ value }) => {
  return (
    <SFStack direction="row" alignItems="center" sx={{ height: "100%" }}>
      <ProgressBarStyled value={value}>
        <div className="complete"></div>
      </ProgressBarStyled>
      {/* <ProgressBar value={value} /> */}
    </SFStack>
  );
};

SFMatchRenderer.propTypes = {
  value: PropTypes.any,
};

export default SFMatchRenderer;
